import React, { useState } from 'react';
import { TextField, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import NumberFormat from 'react-number-format';

export default function Association(props) {
    const [feesamount, setFeesamount] = useState()
    const [feescomment, setFeesComment] = useState()

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }
    const handleFeesamount = (e) => {
        setFeesamount(e.target.value)
        props.values.fees_amount = e.target.value
    }
    const resetInputField = () => {
        setFeesamount("") || setFeesComment("");
        props.values.other_fees_comment = ''
        props.values.fees_amount = ''
    };
    const handleFeescomment = (e) => {
        setFeesComment(e.target.value)
        props.values.other_fees_comment = e.target.value
    }

    return (
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0">
                    Are there other monthly dues or fees such as homeowners association or condo fees?
                </h4>
                <div className="pt-2 form-content-field">
                    <div className="py-2">
                        <RadioGroup
                            row name="other_fees"
                            value={props.values.other_fees}
                            onClick={resetInputField}
                            onChange={props.handleChange} >
                            <div>
                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                            </div>
                            <div>
                                <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                            </div>
                        </RadioGroup>
                        {props.values.other_fees === 'yes' ?
                            <div>
                                <div className="px-3 py-2 w-res-50">
                                    <div className="col-12">
                                        <h6 style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Describe what the fees are for</h6>
                                        <TextField
                                            type="text"
                                            id="other_fees_comment"
                                            variant="outlined"
                                            name="other_fees_comment"
                                            value={props.values.other_fees_comment.trimStart()}
                                            onChange={handleFeescomment, props.handleChange}
                                            placeholder="..."
                                            multiline
                                            className="w-100"
                                            inputprops={{ maxLength: 249 }}
                                            rows={4}
                                        />
                                    </div>
                                </div>
                                <div className="px-3 py-2 w-res-50">
                                    <div className="col-12">
                                        <h6 style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Amount</h6>

                                        <NumberFormat
                                            className="amount-field"
                                            thousandSeparator={','}
                                            decimalSeparator={'.'}
                                            autoComplete='off'
                                            decimalScale={2}
                                            maxLength="10"
                                            prefix="$"
                                            allowNegative={false}
                                            inputMode="numeric"
                                            name="fees_amount"
                                            value={props.values.fees_amount}
                                            onChange={handleFeesamount, props.handleChange}
                                            allowEmptyFormatting />
                                    </div>
                                </div>
                            </div>
                            : ''}
                    </div>
                    {props.validateDisplay4 === true ?
                        props.errors.monthly_dues && props.values.other_fees !== 'no' || (props.values.other_fees === 'yes' && !(props.values.other_fees_comment || props.values.fees_amount)) ?
                            <div className="error-msg" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{}}>{props.errors.monthly_dues}</div> : ''
                        : ''}
                </div>
            </div>
        </div>
    )
}

